<template>
  <li
    class="nav-item"
    :class="{
      'active': isActive,
      'disabled': item.disabled
    }"
  >
    <div class="d-flex justify-content-center align-items-center" v-if="load && item.title == 'Logout'">
      <b-spinner variant="primary" label="Spinning"></b-spinner>
    </div>

    <b-link
      v-else
      v-bind="linkProps"
      class="d-flex align-items-center"
      v-b-tooltip.hover.right="(item.header || item.title)"

    >
      <feather-icon :icon="item.icon" :class="item.title == 'Logout' ? 'flip-horizontal' : '' "/>
      <span :class="item.icon ? 'menu-title text-truncate' : 'menu-title text-truncate ml-2'">{{ t(item.title) }} </span>
      <b-badge
        v-if="item.tag"
        pill
        :variant="item.tagVariant || 'primary'"
        class="mr-1 ml-auto"
      >
        {{ item.tag }}
      </b-badge>
    </b-link>
  </li>
</template>

<script>
import { useUtils as useAclUtils } from '@core/libs/acl'
import { BLink, BBadge, VBTooltip, BSpinner } from 'bootstrap-vue'
import { useUtils as useI18nUtils } from '@core/libs/i18n'
import useVerticalNavMenuLink from './useVerticalNavMenuLink'
import mixinVerticalNavMenuLink from './mixinVerticalNavMenuLink'
import useVerticalNavMenuGroup from '@/@core/layouts/layout-vertical/components/vertical-nav-menu/components/vertical-nav-menu-group/useVerticalNavMenuGroup'
import { mapGetters } from "vuex"

export default {
  components: {
    BLink,
    BBadge,
    BSpinner,
  },
  mixins: [mixinVerticalNavMenuLink],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  computed: {
    ...mapGetters({
      load: "users/logoutLoad" 
    }),
  },
  setup(props) {
    const { isActive, linkProps, updateIsActive } = useVerticalNavMenuLink(props.item)
    const { t } = useI18nUtils()
    const { canViewVerticalNavMenuLink } = useAclUtils()

    return {
      isActive,
      linkProps,
      updateIsActive,
      canViewVerticalNavMenuLink,

      // i18n
      t,
    }
  },

}
</script>
<style scoped>

</style>